
import { Row, Col } from "react-bootstrap";
import { ComparisonContext } from "../../../../config/context/comparisonContext";
import { useContext } from "react";

const CompareTransmission = () => {


    const { compareDetails, setCompareDetails } = useContext(ComparisonContext);

    const carData = compareDetails.first || compareDetails.second || compareDetails.third || compareDetails.fourth
    const transmissionSpecList = carData?.specs?.[3] // index 1 have engine specific records
    const firstCarSpecs = compareDetails?.first?.specs?.[3]
    const secondCarSpecs = compareDetails?.second?.specs?.[3]
    const thirdCarSpecs = compareDetails?.third?.specs?.[3]
    const fourthCarSpecs = compareDetails?.fourth?.specs?.[3]

    return (
        <div className="App">
           {transmissionSpecList && Object.keys(transmissionSpecList).map((spec: any, index: number) => (
                <Row className="border-bottom px-0" key={index}>
                    <Col md={2} className=" comparsion-img-out text-start border-end">
                        <p className="text-start mt-2">{transmissionSpecList[spec].name}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start border-end">
                        <p className="text-start text-dark is-description mt-2">{firstCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start border-end">
                        <p className="text-start text-dark is-description mt-2">{secondCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start border-end">
                        <p className="text-start text-dark is-description mt-2">{thirdCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start">
                        <p className="text-start text-dark is-description mt-2">{fourthCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                </Row>
            )) }

        </div >
    );
};

export default CompareTransmission;
